import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { ManagerDealer } from 'src/app/shared/models/manager-dealer.model';
import { Manager } from 'src/app/shared/models/manager.model';
import { ManagerService } from 'src/app/shared/services/core/manager.service';

@Component({
  selector: 'app-dealers-gen',
  imports: [TegelModule, CommonModule],
  templateUrl: './dealers-gen.component.html',
  styleUrl: './dealers-gen.component.scss'
})
export class DealersGenComponent implements OnInit {
  saveManagerForm!: FormGroup;
  managers: Manager[];
  managerDealer: ManagerDealer[];
  row: Manager;
  pageManager = 1;
  searchText = '';
  order = "user";

  constructor(private utilService: UtilService,
              private formBuilder: FormBuilder,
              private managerService: ManagerService,
              private dialogService: DialogService,
              private toastr: ToastrService
  ) {
    this.managers = [];
    this.managerDealer = [];
    this.row = new Manager();
  }

  ngOnInit(): void {
    this.saveManagerForm = this.formBuilder.group({
      user: ['', Validators.required]
    });

    this.getAllManagers();
  }

  // chooseUser() {
  //   this.dialogService.addDialog(CollaboratorComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.user != null) {
  //        const user = result.user;
  //        this.utilService.setFormControl(this.saveManagerForm, 'user', user.user);
  //     }
  //   });
  // }

  deleteManager(id: any, user: any){ 
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o gerente ' + user + ' ?\n' +
      'Ao excluir o gerente de negócio você desvincula todos os dealers que estavam sobre seu gerenciamento. Você tem certeza? '
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.managerService.delete(id).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do {
              index = this.managers.findIndex(c => c.id === id);
              if (index > -1){
                this.managers.splice(index, 1);
              }
            } while (index != -1);

            this.managerDealer = [];
            this.row = new Manager();

            this.toastr.success('Registro Excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  deleteManagerDealer(dealerCod: any, name: any) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar', 
      message: 'Deseja excluir o dealer ' + name + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed){
        this.managerService.deleteDealer(dealerCod).subscribe((result) => {
          if (result && !result.hasErrors){
            let index = 0;
            do{
              index = this.managerDealer.findIndex(c => c.dealerCod === dealerCod);
              if (index > -1) {
                this.managerDealer.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  getAllManagers() {
    this.managerService.get().subscribe((result) => {
      if (result) {
        this.managers = result;
      }
    });
  }

  getAllDealersByManager(user: string){
    this.managerService.getDealers(user).subscribe((result) => {
      if (result) {
        this.managerDealer = result;
      }
    });
  }

  selectedManager(manager: Manager){
    this.row = manager;
    this.getAllDealersByManager(manager.user);
  }
  
  insertManage(){
    this.managerService.insert(this.saveManagerForm.value).subscribe((resultService) => {
      if (resultService && !resultService.hasErrors) {
        this.managers.unshift(resultService.content);
        this.utilService.setFormControl(this.saveManagerForm, "user", '');
        this.toastr.success('Registro salvo.', 'Sucesso');
      }
    });
  }

  // openSaveManagerDealer(operation: String, managerDealer = new ManagerDealer()) {
  //   managerDealer.userSSB = this.row.user;

  //   this.dialogService.addDialog(SaveManagerDealerComponent, {
  //     managerDealer: managerDealer,
  //     operation: operation
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.success) {
  //       this.getAllDealersByManager(this.row.user);
  //       this.toastr.success('Registro salvo.', 'Sucesso');
  //     }
  //   });
  // }

}
